import PropTypes from 'prop-types';
import React from 'react';

class Tags extends React.Component {
    static propTypes = {
        tags: PropTypes.any.isRequired,
    };

    render() {
        if (this.props.tags.length === 0) {
            return false;
        }

        const tag_list = this.props.tags.map(function(tag, idx) {
            return <li key={idx}>{tag}</li>;
        });

        return (
            <div className="tags clearfix">
                <span className="aural">Tags: </span>
                <i className="cl-icon cl-icon-tag" aria-hidden />
                <ul>{tag_list}</ul>
            </div>
        );
    }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/tags.jsx